import {NavLink} from "react-router-dom";
import {Button} from "reactstrap";

import "./style.scss";

const NavigationButton = (
    {
        btnCustom = 0,
        className = '',
        parentClass = "",
        color = 'primary',
        onClick,
        outline,
        id,
        children,
        isDisabled,
        title,
        icon,
        link,
        type = "button",
        size = "large"
    }) => {

    const ButtonRenderer = parseInt(btnCustom) === 0 ? <Button
        type={type}
        disabled={isDisabled}
        className={`${className} navigation-area-button`}
        color={color}
        id={id}
        onClick={onClick}
        title={title}
        outline={outline}
    >
        {/*<div className="navigation-area-button-triangle"/>*/}
        {
            children && <div className="navigation-area-button-text">
                {children}
            </div>
        }

        {
            icon && <div className="navigation-area-button-icon">
                {icon}
            </div>
        }
    </Button> : <button
        type={type}
        disabled={isDisabled}
        className={`${className} navigation-area-button`}
        color={color}
        id={id}
        onClick={onClick}
        title={title}
    >
        {/*<div className="navigation-area-button-triangle"/>*/}
        {
            children && <div className="navigation-area-button-text">
                {children}
            </div>
        }
        {
            icon && <div className="navigation-area-button-icon">
                {icon}
            </div>
        }
    </button>

    if (link)
        return (
            <NavLink to={link} className={`navigation-area ${size} ${parentClass}`}>
                {ButtonRenderer}
            </NavLink>
        );

    return (
        <div className={`navigation-area ${size} ${parentClass}`}>
            {ButtonRenderer}
        </div>
    );
}

export default NavigationButton;
